import { Room } from "@cruisen/react-shared"
import { collection, doc, getDocs, onSnapshot, updateDoc } from "firebase/firestore"
import { firestore } from "../firebase"

export const subscribeTripRooms = (tripId: string, callback: (rooms: Room[]) => void) => {
  const roomsRef = collection(doc(firestore, "Trips", tripId), "Rooms")

  return onSnapshot(roomsRef, (snapshot) => {
    if (!snapshot || snapshot.empty) return

    const roomsData: Room[] = snapshot.docs.map(
      (room) =>
        ({
          ...room.data(),
          id: room.id,
        }) as Room,
    )

    const sortedRoomsData = roomsData.sort((a, b) => a.created - b.created)

    callback(sortedRoomsData)
  })
}

export const getTripRooms = async (tripId: string): Promise<Room[]> => {
  try {
    const roomsSubCollectionRef = collection(doc(firestore, "Trips", tripId), "Rooms")
    const roomsSnapshot = await getDocs(roomsSubCollectionRef)

    const roomsData: Room[] = roomsSnapshot.docs.map(
      (room) =>
        ({
          ...room.data(),
          id: room.id,
        }) as Room,
    )

    const sortedRoomsData = roomsData.sort((a, b) => a.created - b.created)

    return sortedRoomsData
  } catch (error) {
    console.error("Error fetching trip rooms:", error)
    return []
  }
}

export const updateTripRoom = async (tripId: string, tripRoomId: string, data: Partial<Room>) => {
  const tripRoomRef = doc(firestore, "Trips", tripId, "Rooms", tripRoomId)
  await updateDoc(tripRoomRef, data)
}
